import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  ICCOrderAddOrderFormValues,
  ICCOrderLeg,
  ICCOrderTableReport,
} from "src/Interfaces/ccOrder";

interface ICCOrderSlice {
  addOrderFormValues: ICCOrderAddOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
  editOrderRowValues: ICCOrderTableReport | null;
}

const initialState: ICCOrderSlice = {
  addOrderFormValues: {
    coveredCallOrderBuyLegs: [] as ICCOrderLeg[],
    coveredCallOrderSellLeg: {} as ICCOrderLeg,
  } as ICCOrderAddOrderFormValues,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
  editOrderRowValues: null,
};

const ManualOrderSlice = createSlice({
  name: "ccOrder",
  initialState,
  reducers: {
    setCCOrderOrderFormValues: (
      store,
      action: PayloadAction<ICCOrderAddOrderFormValues | null>,
    ) => {
      store.addOrderFormValues = action.payload;
    },
    onCCOrderFormValuesChange: (
      store,
      action: PayloadAction<{
        name: string;
        value: any;
        name2?: string;
        value2?: any;
        name3?: string;
        value3?: any;
      }>,
    ) => {
      if (action.payload.name3 && action.payload.name2)
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
          [action.payload.name2]: action.payload.value2,
          [action.payload.name3]: action.payload.value3,
        } as ICCOrderAddOrderFormValues;
      else if (action.payload.name2)
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
          [action.payload.name2]: action.payload.value2,
        } as ICCOrderAddOrderFormValues;
      else
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
        } as ICCOrderAddOrderFormValues;
    },
    setCCOrderOrderTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setCCOrderTradeTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
    setCCOrderEditRowValues: (
      store,
      action: PayloadAction<ICCOrderTableReport | null>,
    ) => {
      store.editOrderRowValues = action.payload;
    },
  },
});

export const {
  onCCOrderFormValuesChange,
  setCCOrderEditRowValues,
  setCCOrderOrderFormValues,
  setCCOrderOrderTableFetchDataFlag,
  setCCOrderTradeTableFetchDataFlag,
} = ManualOrderSlice.actions;
export default ManualOrderSlice.reducer;
